import { EventEmitter, Injectable, Output } from '@angular/core';
import { RouteInfo } from '../models/IMenuItem';

@Injectable({providedIn: 'root'})
export class EventsService {

  @Output() defaultTenantdbChanged: EventEmitter<string> = new EventEmitter();
  @Output() currentTenantDbChnaged : EventEmitter<string> = new EventEmitter();
  @Output() menuItemsChanged: EventEmitter<RouteInfo[]> = new EventEmitter();
  @Output() currentTenantIdChanged: EventEmitter<string> = new EventEmitter();
  @Output() currentTenantNameChanged: EventEmitter<string> = new EventEmitter();
  @Output() currentUserNameChanged: EventEmitter<string> = new EventEmitter();
  @Output() tempTenantNameChanged: EventEmitter<string> = new EventEmitter();
  @Output() tempTenantIdChanged: EventEmitter<string> = new EventEmitter();

  constructor() { }
}
